import React from 'react';
import Analytics from './components/Analytics';
import Cards from './components/Cards';
import Footer from './components/Footer';
import Hero from './components/Hero';
import Navbar from './components/Navbar';
import Newsletter from './components/Newsletter';
import Goals from './components/Goals';
import GetInvolved from './components/GetInvolved';
import Events from './components/Events';
import Construction from './components/Construction';


function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <Construction />
      <Footer />
    </div>
  );
}

export default App;
